<template>
    <div class="cc-card" :class="variant" v-ripple @click="$emit('click')">
        <div class="cc-circ">
            <v-icon size="22" color="#FFFFFF">{{ icon }}</v-icon>
        </div>
        <div class="cc-txt">
            <div class="cc-title">{{ label }}</div>
            <div v-if="subtitle" class="cc-sub">{{ subtitle }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'mdi-plus'
        },
        variant: {
            type: String,
            default: 'teal'
        },
        iconSize: {
            type: Number,
            default: 100
        }
    },
}
</script>

<style scoped>
.cc-card {
    height: 112px;
    border-radius: 12px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    cursor: pointer;
    overflow: hidden;
    transition: filter .15s;
    user-select: none;
}

.cc-card:hover {
    filter: brightness(1.08);
}

.cc-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(45deg, rgba(255, 255, 255, .03) 0, rgba(255, 255, 255, .03) 2px, transparent 2px, transparent 12px);
}

.cc-card.teal {
    background: linear-gradient(135deg, #339999 0%, #1a5c5c 100%);
}

.cc-card.green {
    background: linear-gradient(135deg, #009966 0%, #004d33 100%);
}

.cc-card.indigo {
    background: linear-gradient(135deg, #6366f1 0%, #312e81 100%);
}

.cc-card.amber {
    background: linear-gradient(135deg, #d97706 0%, #7c2d12 100%);
}

.cc-circ {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .15);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    flex-shrink: 0;
}

.cc-txt {
    position: relative;
    z-index: 1;
}

.cc-title {
    font-size: 17px;
    font-weight: 800;
    color: #fff;
    letter-spacing: .06em;
    text-transform: uppercase;
}

.cc-sub {
    font-size: 12px;
    color: rgba(255, 255, 255, .65);
    margin-top: 2px;
}
</style>
